import { render, staticRenderFns } from "./ReviewsOfTheDays.vue?vue&type=template&id=b4e32e38&"
import script from "./ReviewsOfTheDays.vue?vue&type=script&lang=js&"
export * from "./ReviewsOfTheDays.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsOfTheDays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports